// 外部から投稿されたデータを表示する(一覧側)。

/*-------------------
    モジュールのimport
---------------------*/
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

/*-------------------
    cssのimport
---------------------*/
import '../css/public.css';
import 'leaflet/dist/leaflet.css';
import 'leaflet-gesture-handling';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';
/*-------------------
    画像のimport
---------------------*/
import imgMapg from '../images/icon/ico-maps.svg';

/*-------------------
    classのimport
---------------------*/
import * as commons from '../commons';
import {
  HavenTableRow,
  PostTableRow,
  RoadTableRow,
  RadioTableRow,
  StandardTableRow,
  AreaTableRow,
} from './createList';
import Footer from '../components/Footer';

// クラス名
class PublicList extends Component {
  constructor(props) {
    super(props);

    // URLを取得。
    const url = props.location.pathname;
    // 市町村を取得する。
    const num = url.lastIndexOf('/');
    const lgCrypt = url.slice(num + 1);

    this.state = { lgCrypt, iconUrl: '', imgModal: [] };
  }

  componentDidMount = async () => {
    const { lgCrypt } = this.state;
    const { lgCd, permission: prmsn } = await commons.getLgCd(lgCrypt);
    if (lgCd === '') {
      commons.moveErrorPage(this.props, '10');
      return;
    }

    // 設定系統を取得する。
    const promise = [];

    // 日本語マスタを取得
    promise.push(commons.commonSetting({ colName: 'M_JP', objName: 'jpMasta' }));

    // 地図設定を取得
    promise.push(commons.commonSetting({ colName: 'M_URL_SETTING', objName: 'mapSetting' }));

    // 市町村設定を取得
    promise.push(commons.commonSetting({ lgCd, colName: 'M_LCL_SETTING', objName: 'lclSetting' }));

    // 全てのプロミスが完了した後に行う処理。
    const results = await Promise.all(promise);
    const resultList = commons.changePromiseRes(results);

    const { jpMasta, lclSetting, mapSetting } = resultList;
    const resSetting = this.getSetting(lclSetting, prmsn);
    const markerSetting = await this.createTable(resSetting, jpMasta, lgCd, prmsn, mapSetting);

    this.setState({ ...resSetting, ...markerSetting, prmsn });
  };

  /**
   * 設定情報を取得する。
   *
   * @memberof PublicList
   */
  getSetting = (lclSetting, prmsn) => {
    // 地方公共団体の情報を取得
    if (lclSetting.length === 0) {
      commons.moveErrorPage(this.props, '10');
      return '';
    }

    const { public_map: publicMap = '' } = lclSetting[0] || '';
    const { title = '', icon_url: iconUrl = '', staff = '', citizen = '' } = publicMap;
    const useSetting = prmsn === 7 ? staff : citizen;
    const { facility = 0 } = useSetting;

    if (title === '') {
      commons.moveErrorPage(this.props, '30');
      return '';
    }

    document.title = title; // タブのタイトルを設定する。

    // faviconの変更
    if (iconUrl !== '') {
      const link = document.querySelector("link[rel~='icon']");
      link.href = iconUrl;
    }

    // URLから中心座標を取得する。
    const { location } = this.props;
    const { search = '' } = location;
    const urlSearch = search;

    return { formTitle: title, iconUrl, facility, urlSearch };
  };

  /**
   * 地図に表示するメーカーを作成する。
   * @memberof BaseMap
   */
  createTable = async (resSetting, jpMasta, lgCd, prmsn, mapSetting) => {
    const { facility } = resSetting;

    // 設定系統を取得する。
    const promise = [];

    const comObj = { lgCd, pubFlag: prmsn === 4 ? true : '' };

    // 避難所を取得
    if (facility & 1) {
      promise.push(commons.getMarker({ ...comObj, colName: 'M_HAVEN', objName: 'havenData' }));
    }

    // 投稿データを取得
    if (facility & 2) {
      promise.push(
        commons.getMarker({ ...comObj, colName: 'T_POST_RESIDENT', objName: 'postData' })
      );
    }

    // 通行止め情報を取得
    if (facility & 4) {
      promise.push(commons.getMarker({ ...comObj, colName: 'T_ROAD_CLOSE', objName: 'roadData' }));
    }

    // 屋外子局を取得
    if (facility & 8) {
      promise.push(commons.getMarker({ lgCd, colName: 'M_DP_RADIO', objName: 'radioData' }));
    }

    // 汎用マーカーを取得
    if (facility & 16) {
      promise.push(
        commons.getMarker({ ...comObj, colName: 'M_STANDARD_MARKER', objName: 'stdData' })
      );
    }

    // 作図エリアを取得
    if (facility & 32) {
      promise.push(commons.getMarker({ ...comObj, colName: 'M_AREA_MARKER', objName: 'areaData' }));
    }

    // 全てのプロミスが完了した後に行う処理。
    const results = await Promise.all(promise);
    const resultList = commons.changePromiseRes(results);
    const {
      havenData = [],
      postData = [],
      radioData = [],
      roadData = [],
      stdData = [],
      areaData = [],
    } = resultList;

    // 地図の設定を取得
    const { map_url: mapUrl = '' } = mapSetting[0];
    const { tile_url: tileUrl = '', tile_attribution: tileAttribution = '' } = mapUrl;

    // 引数の共通要素
    const comProp = {
      tileUrl,
      tileAttribution,
      prmsn,
      jpList: jpMasta,
      onClickImg: this.onClickImg,
    };

    // 各一覧を作成する。
    const havenList = [];
    for (let i = 0; i < havenData.length; i += 1) {
      havenList.push(<HavenTableRow data={havenData[i]} comProp={comProp} key={`haven_${i}`} />);
    }

    const postList = [];
    for (let i = 0; i < postData.length; i += 1) {
      postList.push(<PostTableRow data={postData[i]} comProp={comProp} key={`post_${i}`} />);
    }

    const roadList = [];
    for (let i = 0; i < roadData.length; i += 1) {
      roadList.push(<RoadTableRow data={roadData[i]} comProp={comProp} key={`road_${i}`} />);
    }

    const radioList = [];
    for (let i = 0; i < radioData.length; i += 1) {
      radioList.push(<RadioTableRow data={radioData[i]} comProp={comProp} key={`radio_${i}`} />);
    }

    const standardList = [];
    for (let i = 0; i < stdData.length; i += 1) {
      standardList.push(<StandardTableRow data={stdData[i]} comProp={comProp} key={`std_${i}`} />);
    }

    const areaList = [];
    for (let i = 0; i < areaData.length; i += 1) {
      areaList.push(<AreaTableRow data={areaData[i]} comProp={comProp} key={`area_${i}`} />);
    }

    let tmpFcmly = 0;
    if (havenList.length > 0) tmpFcmly += 1;
    if (postList.length > 0) tmpFcmly += 2;
    if (roadList.length > 0) tmpFcmly += 4;
    if (radioList.length > 0) tmpFcmly += 8;
    if (standardList.length > 0) tmpFcmly += 16;
    if (areaList.length > 0) tmpFcmly += 32;

    return {
      fcmlyFlag: tmpFcmly,
      havenList,
      postList,
      roadList,
      radioList,
      standardList,
      areaList,
    };
  };

  /**
   * 画面遷移
   * @memberof PublicList
   */
  onClickBtnMove = () => {
    const { history } = this.props;
    const { urlSearch = '', lgCrypt } = this.state;
    history.push({ pathname: `../map/${lgCrypt}`, search: urlSearch });
  };

  /**
   * 種別のボタンを作成する。
   * @memberof PublicList
   */
  menuBtn = (objKey, tmpValue, dispName, dataDisp) => {
    const { [objKey]: objValue } = this.state;
    if (dataDisp === 0) return [];

    const setValue = objValue & tmpValue ? objValue - tmpValue : objValue + tmpValue;
    const choice = (objValue & tmpValue) > 0;

    return (
      <button
        className={`kindBtn ${choice ? '' : 'kindBtnDis'}`}
        type="button"
        onClick={() => this.setState({ [objKey]: setValue })}
      >
        {dispName}
      </button>
    );
  };

  /**
   * ポップアップの画像を押した際の処理
   * @memberof PublicMap
   */
  onClickImg = (setModal) => {
    this.setState({ imgModal: setModal });
  };

  /**
   * テスト用
   *
   * @memberof PublicList
   */
  test = () => {};

  render() {
    const {
      lgCrypt,
      imgModal,
      formTitle,
      iconUrl,
      fcmlyFlag = 0,
      havenList = [],
      postList = [],
      roadList = [],
      radioList = [],
      standardList = [],
      areaList = [],
      prmsn,
    } = this.state;

    return (
      <div>
        {imgModal}
        <div className="head-sticky">
          <div className="pb_list_title">
            <div>
              {iconUrl === '' ? null : <img className="site-icon" src={iconUrl} alt="" />}
              {formTitle}
            </div>
            <div style={{ fontWeight: '100' }}>
              <img src={imgMapg} alt="地図アイコン" className="icon" />
              <button
                type="button"
                className="btnAtag"
                onClick={() => this.onClickBtnMove(`../map/${lgCrypt}`)}
              >
                地図表示
              </button>
            </div>
          </div>
          <div>
            <div className="button-scroll-wrapper">
              {this.menuBtn('fcmlyFlag', 1, '避難所', havenList.length)}
              {this.menuBtn('fcmlyFlag', 2, '投稿データ', postList.length)}
              {this.menuBtn('fcmlyFlag', 4, '道路規制', roadList.length)}
              {this.menuBtn('fcmlyFlag', 8, '屋外子局', radioList.length)}
              {this.menuBtn('fcmlyFlag', 16, '汎用マーカー', standardList.length)}
              {this.menuBtn('fcmlyFlag', 32, '作図エリア', areaList.length)}
            </div>
          </div>
        </div>
        {/* 避難所のテーブル */}
        {fcmlyFlag & 1 ? (
          <>
            <div className="pb_table_title">避難所</div>
            <table className="pb_table">
              <thead>
                <tr>
                  <th>状態</th>
                  <th>種別</th>
                  <th>名称</th>
                  <th className="hide-col">住所</th>
                  <th className="hide-col">収容人数</th>
                  <th className="hide-col">電話番号</th>
                </tr>
              </thead>
              <tbody>{havenList}</tbody>
            </table>
          </>
        ) : null}
        {/* 投稿データのテーブル */}
        {fcmlyFlag & 2 ? (
          <>
            <div className="pb_table_title">投稿データ</div>
            <table className="pb_table">
              <thead>
                <tr>
                  {prmsn === 7 ? <th>状態</th> : null}
                  <th>種別</th>
                  <th>名称</th>
                  <th className="hide-col">発生日時</th>
                  <th className="hide-col">画像</th>
                </tr>
              </thead>
              <tbody>{postList}</tbody>
            </table>
          </>
        ) : null}
        {/* 道路規制のテーブル */}
        {fcmlyFlag & 4 ? (
          <>
            <div className="pb_table_title">道路規制</div>
            <table className="pb_table">
              <thead>
                <tr>
                  <th>種別</th>
                  <th>名称</th>
                  <th className="hide-col">開始時間</th>
                  <th className="hide-col">終了時間</th>
                </tr>
              </thead>
              <tbody>{roadList}</tbody>
            </table>
          </>
        ) : null}
        {/* 屋外子局のテーブル */}
        {fcmlyFlag & 8 ? (
          <>
            <div className="pb_table_title">屋外子局</div>
            <table className="pb_table">
              <thead>
                <tr>
                  <th>コード</th>
                  <th>名称</th>
                </tr>
              </thead>
              <tbody>{radioList}</tbody>
            </table>
          </>
        ) : null}
        {/* 汎用マーカーのテーブル */}
        {fcmlyFlag & 16 ? (
          <>
            <div className="pb_table_title">汎用マーカー</div>
            <table className="pb_table">
              <thead>
                <tr>
                  <th>種別</th>
                  <th>名称</th>
                </tr>
              </thead>
              <tbody>{standardList}</tbody>
            </table>
          </>
        ) : null}
        {/* 作図エリアのテーブル */}
        {fcmlyFlag & 32 ? (
          <>
            <div className="pb_table_title">作図エリア</div>
            <table className="pb_table">
              <thead>
                <tr>
                  <th>エリア</th>
                  <th>名称</th>
                  <th className="hide-col">フリー記載</th>
                </tr>
              </thead>
              <tbody>{areaList}</tbody>
            </table>
          </>
        ) : null}
        <Footer />
      </div>
    );
  }
}

PublicList.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default withRouter(PublicList);
